<script>
import { listCoupon, refresh, addCoupon, updateCoupon } from '../../../api/renzhen';
import en from 'element-ui/lib/locale/lang/en'
import zh from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'

export default {
  components: {},
  data() {
    return {
      list: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true,
      },
      en,
      zh,
      loading: false,
      pageNo: 1,
      limit: 10,
      total: 0,
      updateform: {
        companyName: '',
        linkMan: '',
        linkPhone: '',
        frealQty: '',
        rkQty: '',
        rkState: '',
        machineType: '',
        machineNum: '',
        couponId:''

      },
      addform: {
        companyName: '',
        linkMan: '',
        linkPhone: '',
        frealQty: '',
        fCustomerId: '',
        fDate: '',
        machineType: '',
        machineNum: '',

      },
      formLabelWidth: '120px',
      updateFormVisible: false
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang(v) {
      locale.use(this[v])
    }
  },
  created() {
    locale.use(this[this.lang])
    this.authorities = JSON.parse(sessionStorage.getItem('authorities'))
    this.loading = true
  },
  mounted() {
    this.ListC()
  },
  methods: {
    async ListC(pager = 1) {
      this.pageNo = pager
      // const formdata = new FormData()
      // formdata.append('searchParam', select.searchParam)
      // formdata.append('applicantTimeStart', select.applicantTimeStart)
      // formdata.append('applicantTimeEnd', select.applicantTimeEnd)
      // formdata.append('state', select.state)
      const result = await listCoupon(this.pageNo, this.limit)
      console.log(result);
      if (result.code == 0) {
        this.total = result.data.total
        this.list = result.data.records
        console.log(this.list);
      } else {
        this.$notify.error({
          title: this.$t('messages.error'),
          message: result.message
        });
      }
    },

    toInsertView() {
      this.$router.push({ path: '/equipment/list/submit/add' })
    },
    async handleRefresh() {
      await refresh()
      await this.ListC()

    },
    OpenUpdateForm(a) {
      console.log(a);
      this.updateform.companyName = a.companyName
      this.updateform.linkMan = a.linkMan
      this.updateform.linkPhone = a.linkPhone
      this.updateform.frealQty = a.frealQty
      this.updateform.rkQty = a.rkQty
      this.updateform.rkState = a.rkState
      if(a.machineType == null){
        this.updateform.machineType = ''
      }else{
        this.updateform.machineType = a.machineType
      }
      if(a.machineType == null){
        this.updateform.machineNum = ''
      }else{
        this.updateform.machineNum = a.machineNum
      }
      this.updateform.couponId = a.couponId
      this.updateFormVisible = true
    },
    async confire() {
      const formdata = new FormData()
      formdata.append('couponId', this.updateform.couponId)
      formdata.append('companyName', this.updateform.companyName)
      formdata.append('linkMan', this.updateform.linkMan)
      formdata.append('linkPhone', this.updateform.linkPhone)
      formdata.append('fRealQty', this.updateform.frealQty)
      formdata.append('rkQty', this.updateform.rkQty)
      formdata.append('rkState', this.updateform.rkState)
      formdata.append('machineType', this.updateform.machineType)
      formdata.append('machineNum', this.updateform.machineNum)
      const result = await updateCoupon(formdata)
      if (result.code == 0) {
        this.$notify.success({
          title: this.$t('messages.success'),
          message: result.message
        });
        await this.ListC()
        this.updateFormVisible = false
      } else {
        this.$notify.error({
          title: this.$t('messages.fail'),
          message: result.message
        });
        this.updateFormVisible = false
      }
    }
  }
}

  ;
</script>
<template>
  <div>
    <div style="width: 100%; height: 100%">
      <div class="equipmentList">
        <div class="container">
          <div>
            <span>{{ $t('renzhen.title') }}</span>
          </div>
          <div>
            <a-space>
              <a-button
                type="primary"
                @click="handleRefresh"
              >{{ $t('buttons.refresh') }}</a-button>
              <a-button
                type="primary"
                v-if="authorities.find(a => a.code.split(':')[2] === 'query')"
              >{{ $t('buttons.search') }}</a-button>
              <a-button
                key="submit"
                type="primary"
                @click="toInsertView"
                v-if="authorities.find(a => a.code.split(':')[2] === 'insert')"
              >{{ $t('buttons.add') }}</a-button>
            </a-space>
          </div>
        </div>
        <el-table
          :data="list"
          border
        >
          <el-table-column
            prop="companyName"
            :label="$t('common.customerName')"
            width="180"
          >
          </el-table-column>
          <el-table-column
            prop="fbillNo"
            :label="$t('renzhen.fbillNo')"
            width="160"
          >
          </el-table-column>
          <el-table-column
            prop="linkMan"
            :label="$t('orders.contactPerson')"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="linkPhone"
            :label="$t('customer.mobile')"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="fDate"
            :label="$t('renzhen.fDate')"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="availableQty"
            :label="$t('renzhen.availableQty')"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="frealQty"
            :label="$t('renzhen.frealQty')"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="machineNum"
            :label="$t('device.code')"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="machineType"
            :label="$t('common.deviceType')"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="rkQty"
            :label="$t('renzhen.rkQty')"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="rkState"
            :label="$t('renzhen.rkState')"
            width="120"
          >
          </el-table-column>
          <el-table-column
            prop="usedQty"
            :label="$t('renzhen.usedQty')"
            width="120"
          >
          </el-table-column>
          <el-table-column
            :label="$t('common.operation')"
            width="100"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="OpenUpdateForm(scope.row)"
              >{{ $t('buttons.edit') }}</el-button>
              <el-button
                type="text"
                size="small"
              >{{ $t('buttons.delete') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="ListC"
          @current-change="ListC"
          :pager-count="9"
          :current-page="pageNo"
          :page-size="limit"
          :page-sizes="[10, 20, 30, 40]"
          :background="true"
          layout="prev, pager, next"
          :total="total"
        />
      </div>

    </div>
    <el-dialog
      :title="$t('renzhen.editTitle')"
      :visible.sync="updateFormVisible"
      :show-close=false
      :append-to-body="true"
      width="900px"
    >
      <el-form :model="updateform">
        <el-form-item
          :label="$t('customer.company')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="updateform.companyName"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('orders.contactPerson')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="updateform.linkMan"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('customer.mobile')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="updateform.linkPhone"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('renzhen.frealQty')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="updateform.frealQty"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('renzhen.rkQty')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="updateform.rkQty"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('renzhen.rkState')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="updateform.rkState"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('common.deviceType')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="updateform.machineType"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('device.code')"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="updateform.machineNum"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="updateFormVisible = false">{{ $t('common.cancelText') }}</el-button>
        <el-button
          type="primary"
          @click="confire"
        >{{ $t('common.okText') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<style lang="less" scoped>
.row {
  margin-top: 5px;
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}

.equipmentList {
  padding: 15px;
  width: 100%;
  height: 100%;
}

.equipmentList .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 20px;
}
</style>
